import { Table } from "react-bootstrap";
import { useState, useContext } from "react";
import "../components/Reminder.css";
import { UserDataContext } from "../components/UserDataContext";
import DataGroupUsers from "./DataGroupUsers";
import "../components/button.css";
import Button from "@mui/material/Button";

export default function DataTable({ data, onUpdate }) {
  const { userData } = useContext(UserDataContext);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [selectedId, setSelectedId] = useState(null);
  const [eye, setEye] = useState("fa fa-eye");
  const [isDataVisible, setIsDataVisible] = useState(false);
  const [groupName, setGroupName] = useState({});
  const handleShow = (id) => {
    setGroupName({
      id: id,
      grpName: data[0].name,
    });

    if (selectedId === id && isDataVisible) {
      setSelectedId(null);
      setIsDataVisible(false);
      setEye("fa fa-eye");
    } else {
      setSelectedId(id);
      setIsDataVisible(true);
      setEye("fa fa-eye-slash");
    }
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key === null) return 0;
    const direction = sortConfig.direction === "asc" ? 1 : -1;

    if (a[sortConfig.key] < b[sortConfig.key]) {
      return -1 * direction;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return 1 * direction;
    }
    return 0;
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      {userData && userData.userId > 0 && (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="td-centered" onClick={() => requestSort("id")}>
                ID
              </th>
              <th onClick={() => requestSort("name")}>Utworzył</th>
              <th onClick={() => requestSort("fullName")}>Właściciel</th>
              <th className="td-centered">Pokaż</th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr key={item.id}>
                <td className="td-centered">{item.id}</td>
                <td>{item.name}</td>
                <td>{item.fullName}</td>
                <td className="td-centered">
                  <Button
                    variant="outlined"
                    onClick={() => handleShow(item.id)}
                  >
                    <i
                      className={
                        selectedId === item.id && isDataVisible
                          ? "fa fa-eye-slash"
                          : "fa fa-eye"
                      }
                      aria-hidden="true"
                    ></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      {selectedId && isDataVisible && <DataGroupUsers group={groupName} />}
    </div>
  );
}
